import { uuid } from '../utils';
import {
  ILLUSTRATION
} from './categories';

export default {
  id: uuid(),
  priority: 3,
  name: 'Editorials',
  thumbnail: './Editorials/Edit-Thumb.jpg',
  categories: [ ILLUSTRATION ],
  content: [
    './Editorials/End_ofthe_World.jpg',
    './Editorials/Play.jpg',
    './Editorials/Soros-Tree.jpg',
    './Editorials/Soros-Detail.jpg',
    './Editorials/Tatal.jpg',
    './Editorials/Babuin.jpg',
    './Editorials/Coperta_int_play.jpg',
    './Editorials/DOR4-a.jpg',
    './Editorials/DOR4-b.jpg',
    './Editorials/PointofNo.jpg',
    './Editorials/Porcu.jpg',
    './Editorials/Technophilia.jpg',
    './Editorials/DarkWindow.jpg',
    './Editorials/IlustratieCoperta.jpg',
    './Editorials/Tierkonferenz.jpg',
    './Editorials/parade.jpg'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/editorials.js